export const LANDING = '/';
export const LOGIN = '/login';
export const REGISTER = '/register';
